module.exports = __webpack_public_path__ + "static/img/operaingFinance.b9de605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operaingFinance.png
// module id = fe34
// module chunks = 1